<div class="top-bar-content">
  <app-auth-header [title]="'Create Password'" [showMenu]="false"></app-auth-header>
</div>
<div class="auth-content">
  <div>
    <div class="subtext centered-with-padding">
      <p>The url has expired! Please <a class="auth-link blue-link" routerLink="/reset-password">request a password.</a></p>
    </div>
  </div>
  <app-footer-eprove-links></app-footer-eprove-links>
</div>
